import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { formatInlineText, InlineStyle } from '@/util/inlineFormatting';


export default /*#__PURE__*/_defineComponent({
  __name: 'AIFormattedText',
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as { text: string }


const spoilersRevealed = ref(false);
const segments = computed(() => formatInlineText(props.text));

function isHiddenSpoiler(styles: InlineStyle[]): boolean {
  return styles.includes('spoiler') && !spoilersRevealed.value;
}

function revealSpoiler(styles: InlineStyle[]) {
  if (styles.includes('spoiler'))
    spoilersRevealed.value = true;
}

return { __sfc: true,props, spoilersRevealed, segments, isHiddenSpoiler, revealSpoiler }
}

})